import { useEffect, useRef, useState } from "react";
import { useNavigate, useSearchParams } from "react-router-dom";
import axios from "axios";
import { useAuth } from "../auth/AuthContext";
import "../components/Billing.css";

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

export default function BillingSuccess() {
  const [params] = useSearchParams();
  const navigate = useNavigate();
  const { checkAuth } = useAuth();
  const sessionId = params.get("session_id");
  const ran = useRef(false);
  const [state, setState] = useState("checking"); // checking | done | timeout

  useEffect(() => {
    if (ran.current) return;
    ran.current = true;
    if (!sessionId) { setState("timeout"); return; }
    let attempts = 0;
    const poll = async () => {
      attempts += 1;
      try {
        const { data } = await axios.get(`${API}/billing/status/${sessionId}`);
        if (data.paid) { await checkAuth(); setState("done"); return; }
      } catch { /* keep polling */ }
      if (attempts >= 6) { setState("timeout"); return; }
      setTimeout(poll, 2000);
    };
    poll();
  }, [sessionId, checkAuth]);

  if (state === "checking") {
    return (
      <div className="bsuccess" data-testid="billing-checking">
        <div className="ring" />
        <h1>Confirming your payment…</h1>
        <p>One moment while we activate your access. This usually takes just a few seconds.</p>
      </div>
    );
  }
  if (state === "timeout") {
    return (
      <div className="bsuccess" data-testid="billing-timeout">
        <h1>Payment is processing</h1>
        <p>Your payment is being finalized. Your access will activate automatically — check your account in a moment.</p>
        <button className="bbtn" onClick={() => navigate("/account")} data-testid="billing-account-btn">Go to Account</button>
      </div>
    );
  }
  return (
    <div className="bsuccess" data-testid="billing-done">
      <div className="check">✓</div>
      <h1>You're all set</h1>
      <p>Your purchase is confirmed and your Liturgical Intelligence™ access is now active.</p>
      <button className="bbtn" onClick={() => navigate("/dashboard")} data-testid="billing-dashboard-btn">Go to Dashboard</button>
    </div>
  );
}
